export default __webpack_public_path__ + "assets/img/logoterbaruhcm.57adfdf4346cc26072528b905a9dd853.png";